import { render } from "./dokter.vue?vue&type=template&id=00525931&scoped=true"
import script from "./dokter.vue?vue&type=script&lang=js"
export * from "./dokter.vue?vue&type=script&lang=js"

import "./dokter.vue?vue&type=style&index=0&id=00525931&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00525931"]])

export default __exports__